<template>
  <ul class="product-group" v-if="products">
    <li :class="'ticket-group-list ' + checkedClass('group_'+productGroupNum+'_'+index)" v-for="(data, index) in products" :key="'list_'+productGroupNum+'_'+index">
      <span class="product-name-box">
        <input type="radio" :id="productGroupNum+index" name="voucher" :value="'group_'+productGroupNum+'_'+index" v-model="selectedValue">
        <label :for="productGroupNum+index">
          <span :class="'product-name ' + noDescription">{{ data.concurrency[0].product_name }}</span>
          <span class="product-discription" v-if="passgroupType !== 'one' && passgroupType !== 'package'">
            {{ data.concurrency[0].description }}
          </span>
          <p class="product-price" :style="'color: ' + productColor + ';'">
            {{ setNumberCommas(data.concurrency[0].amount) }}원<template v-if="passgroupType === 'one' || passgroupType === 'package'">/{{data.concurrency[0].use_day}}</template>
          </p>
          <!-- 패키지 영화 리스트 -->
          <div v-if="passgroupType === 'package' && packageList && packageList.length > 0" class="product-package">
            <ul>
              <li v-for="(detail, index) in packageList" :key="'package_info_' + index">
                <span class="product-package-img">
                  <img :src="'https://' + detail.image" :alt="detail.title">
                </span>
                <span class="product-package-title">
                  <span>{{ detail.title }}</span>
                </span>
              </li>
            </ul>
          </div>
        </label>
      </span>
    </li>
  </ul>
</template>
<script>
import _ from 'lodash'
import { setNumberCommas } from '@/common/utils/common'

export default {
  props: {
    packageDetailMap: {
      type: Object
    },
    productUserCount: {
      type: String,
      default: '1'
    },
    products: {
      type: Array,
      required: true
    },
    productColor: {
      type: String,
      required: true,
      default: '#1351f9'
    },
    productGroupNum: {
      type: String,
      required: true
    },
    passgroupType: {
      type: String,
      required: true
    },
    contentId: {
      type: String
    },
    contentType: {
      type: String``
    },
    currentIndex: {
      type: String
    }
  },
  data () {
    return {
      selectedValue: this.currentIndex
    }
  },
  computed: {
    noDescription () {
      return this.passgroupType === 'one' || this.passgroupType === 'package' ? 'no-description' : ''
    },
    packageList () {
      if (this.passgroupType === 'package') {
        const productId = _.get(this.products, '0.concurrency.0.productid', null)
        if (productId === null) return []
        return this.packageDetailMap[productId]
      } else {
        return []
      }
    }
  },
  methods: {
    setNumberCommas (price) {
      return setNumberCommas(price)
    },
    checkedClass (indexInfo) {
      if (this.currentIndex === indexInfo) {
        return ' checked'
      }
    }
  },
  watch: {
    selectedValue () {
      const indexInfo = this.selectedValue.split('_')
      this.$events.$emit('popupSelectedVoucher', { list: this.products[indexInfo[3]], selectedIndex: this.selectedValue, productType: this.passgroupType })
    }
  }
}
</script>
